import * as amplitude from '@amplitude/analytics-browser'

amplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY, undefined, {
    defaultTracking: true
})

export default amplitude
